module.exports = __webpack_public_path__ + "img/Stock-Exchange.01e15797.png";